import { useMutation } from "@tanstack/react-query";
import { copyTravelersFromOrder } from "../../api/administration/serviceOrderApi";

export const useCopyTravelers = (destinationOrderId, onSuccessCallback) => {
  return useMutation({
    mutationFn: (payload) => copyTravelersFromOrder(destinationOrderId, payload),
    onSuccess: onSuccessCallback,
  });
};